import { Component } from "react";


export default class LandingPage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return(
            <div style={{ width: "90%", minHeight: "100vh", margin: "0 auto", paddingTop: "1%",
                backgroundColor: "var(--surface-300)" }}>

                <div style={{textAlign: "center"}}>
                    <h1>Kalayaan Castle Holonet Services</h1>
                </div>

                <div style={{textAlign: "center", paddingLeft: "5%", paddingRight: "5%"}}>
                    <p>Welcome to the Kalayaan Castle Holonet Services portal.</p>
                    <p>Brought to you by the Tresario Star Kingdom Ministry of State.</p>
                </div>

            </div>
        );
    }
}